export default __webpack_public_path__ + "app/images/ic-28-type-file.svg";